import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import de from './locales/de.json';
import ptBR from './locales/pt-BR.json';

export type AppLocale = 'en' | 'de' | 'pt-BR';

export const LOCALE_STORAGE_KEY = 'app_locale';

export const SUPPORTED_LOCALES: Array<{
  code: AppLocale;
  label: string;
  flag: string;
}> = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'pt-BR', label: 'Português (BR)', flag: '🇧🇷' },
];

const savedLocale = localStorage.getItem(
  LOCALE_STORAGE_KEY
) as AppLocale | null;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    'pt-BR': { translation: ptBR },
  },
  lng: savedLocale || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
